<template>
  <div>
    <OrderChecklistItem
      v-if="isSendOrderEnabled"
      :order="order"
      title="Send Order Confirmation"
      description="Will email the order details to the customer to confirm the order has been entered"
      actionTitle="Send"
      actionIcon="fa-envelope"
      :type="OrderChecklistItemTypes.sendOrderConfirmation"
      @complete="$emit('sendOrder')"
      @skip="$emit('skip', OrderChecklistItemTypes.sendOrderConfirmation)"
    />

    <OrderChecklistItem
      v-if="isPrintSheetsEnabled"
      :order="order"
      title="Print Production Sheets"
      description="Will print the order production sheets for use in production"
      actionTitle="Print Production"
      actionIcon="fa-print"
      secondaryActionTitle="Print Customer"
      secondaryActionIcon="fa-print"
      :type="OrderChecklistItemTypes.printProductionSheets"
      @complete="$emit('printProductionSheets')"
      @completeSecondary="$emit('printCustomerSheets')"
      @skip="$emit('skip', OrderChecklistItemTypes.printProductionSheets)"
    />

    <OrderChecklistItem
      v-if="isPrintLabelsEnabled"
      :order="order"
      title="Print Production Labels"
      description="Will print the order production labels for use on the glass panels"
      actionTitle="Print"
      actionIcon="fa-print"
      :type="OrderChecklistItemTypes.printProductionLabels"
      @complete="$emit('printLabels')"
      @skip="$emit('skip', OrderChecklistItemTypes.printProductionLabels)"
    />

  </div>
</template>


<script>
import { mapState } from 'vuex'

import Utils from '@/utils/utils'
import OrderChecklistItem from '@/modules/orders/components/orderChecklistItem'
import OrderActionDialog from '@/modules/orders/views/orderActionDialog'

import { OrderChecklistItemTypes, OrderChecklistStatusTypes, OrderChecklistItemTypeLookup, AccountSettingKeys } from '@/store/types'

export default {
  name: 'OrderChecklistItemList',
  components: {
    OrderChecklistItem
  },
  props: {
    order: Object
  },
  created() {
    this.OrderChecklistItemTypes = OrderChecklistItemTypes
    this.OrderChecklistStatusTypes = OrderChecklistStatusTypes
  },
  computed: {
    ...mapState({
      accountSettings: state => state.account.accountSettings
    }),
    isSendOrderEnabled() {
      return parseInt(this.accountSettings[AccountSettingKeys.orderPreProdEnableSendOrder] || 0) != 0
    },
    isPrintSheetsEnabled() {
      return parseInt(this.accountSettings[AccountSettingKeys.orderPreProdEnablePrintSheets] || 0) != 0
    },
    isPrintLabelsEnabled() {
      if(!this.order || !this.order.requiresProduction)
        return false

      return parseInt(this.accountSettings[AccountSettingKeys.orderPreProdEnablePrintLabels] || 0) != 0
    }
  },
  
  methods: {
  }
}
</script>